import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/shared/ui/Toast';
import { adSettingsApi, type AdSettings } from '../../api/adSettingsApi';
import { adSettingsKeys } from '../../queryKeys';

/** One location's ad settings, and a save that puts what the server returns straight back in the cache. */
export function useAdSettings(locationId: string) {
  const queryClient = useQueryClient();
  const toast = useToast();
  const queryKey = adSettingsKeys.settings(locationId);
  const query = useQuery({
    queryKey,
    queryFn: () => adSettingsApi.get(locationId),
    enabled: !!locationId,
  });
  const save = useMutation({
    mutationFn: (fn: () => Promise<AdSettings>) => fn(),
    onSuccess: (saved) => {
      queryClient.setQueryData(queryKey, saved);
      toast.success('Saved.');
    },
    onError: (err: Error) => toast.error(err.message ?? 'Could not save.'),
  });
  return { ...query, save };
}
